import { Directive, ElementRef, Input, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[tynAd]',
})
export class AdDirective {
  constructor(
    public viewContainerRef: ViewContainerRef,
    public elementRef: ElementRef
  ) {}
}
